export default async function fetchAdobeTestData(): Promise<null | AdobeResponseToken[]> {
    console.log('fetchAdobe start');
    return new Promise((resolve, reject) => {
        // if (process.env.GATSBY_EH_ENV === 'local') {
        //     console.log('IS LOCAL!!!!');
        //     resolve([
        //         {
        //             'activity.id': '1388304',
        //             'profile.requestUsedGetOffer': 'false',
        //             'experience.name': 'A',
        //             'activity.name': 'Test Activity 52798',
        //             'profile.allianceId': 'Med34728',
        //             'profile.visitedQuotePage': 'no',
        //         },
        //         {
        //             'activity.id': '1388304',
        //             'profile.requestUsedGetOffer': 'false',
        //             'experience.name': 'A',
        //             'activity.name': 'Second Fake Test Activity 52798',
        //             'profile.allianceId': 'Med34728',
        //             'profile.visitedQuotePage': 'no',
        //         },
        //     ]);
        // } else {
        console.log('NON LOCAL!');
        document.addEventListener(
            'at-request-succeeded',
            function (e: CustomEventInit<{ responseTokens: AdobeResponseToken[] }>) {
                console.log('ADOBE RESPONSE!!!!', e);
                console.log(e?.detail?.responseTokens);
                if (e?.detail?.responseTokens) {
                    resolve(e.detail.responseTokens);
                } else {
                    reject(null);
                }
            }
        );
        // }
    });
}
